import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Settings, Wrench, FileText, CheckSquare, Palette, Star } from 'lucide-react';
import { FieldConfigurationSettings } from './partner/FieldConfigurationSettings';
import { TradeSpecialtiesManager } from './partner/TradeSpecialtiesManager';
import { DocumentTypesManager } from './partner/DocumentTypesManager';
import { PrequalificationSettings } from './partner/PrequalificationSettings';
import { ContractorPortalBranding } from './partner/ContractorPortalBranding';
import { RatingWeightsSettings } from './partner/RatingWeightsSettings';

export function PartnerManagementSettings() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">Partner Management</h2>
        <p className="text-muted-foreground">
          Configure contractor and vendor management settings for your organization
        </p>
      </div>

      <Tabs defaultValue="fields" className="space-y-6">
        <TabsList className="grid w-full grid-cols-6">
          <TabsTrigger value="fields">
            <Settings className="h-4 w-4 mr-2" />
            Fields
          </TabsTrigger>
          <TabsTrigger value="trades">
            <Wrench className="h-4 w-4 mr-2" />
            Trades
          </TabsTrigger>
          <TabsTrigger value="documents">
            <FileText className="h-4 w-4 mr-2" />
            Documents
          </TabsTrigger>
          <TabsTrigger value="prequalification">
            <CheckSquare className="h-4 w-4 mr-2" />
            Prequalification
          </TabsTrigger>
          <TabsTrigger value="branding">
            <Palette className="h-4 w-4 mr-2" />
            Portal
          </TabsTrigger>
          <TabsTrigger value="ratings">
            <Star className="h-4 w-4 mr-2" />
            Ratings
          </TabsTrigger>
        </TabsList>

        <TabsContent value="fields" className="space-y-6">
          <FieldConfigurationSettings />
        </TabsContent>

        <TabsContent value="trades" className="space-y-6">
          <TradeSpecialtiesManager />
        </TabsContent>

        <TabsContent value="documents" className="space-y-6">
          <DocumentTypesManager />
        </TabsContent>

        <TabsContent value="prequalification" className="space-y-6">
          <PrequalificationSettings />
        </TabsContent>

        <TabsContent value="branding" className="space-y-6">
          <ContractorPortalBranding />
        </TabsContent>

        <TabsContent value="ratings" className="space-y-6">
          <RatingWeightsSettings />
        </TabsContent>
      </Tabs>
    </div>
  );
}
